var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "samc-popover",
        {
          ref: "wrapper",
          staticClass: "hidden",
          attrs: { show: _setup.showPopover, trigger: "click" },
          on: {
            openpopover: function ($event) {
              _setup.showPopover = true
            },
            closepopover: function ($event) {
              _setup.showPopover = false
            },
          },
        },
        [
          _c("i", {
            staticClass:
              "mdi mdi-database text-2xl text-secondary-900 cursor-pointer",
            attrs: { slot: "target" },
            slot: "target",
          }),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-col mx-[-4px] text-left" }, [
            _c(
              "a",
              {
                staticClass:
                  "px-3 py-2 cursor-pointer border-0 border-b border-solid border-gray-500 hover:bg-gray-300",
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return (() => {
                      _setup.showPackageModal = true
                      _setup.showPopover = false
                    }).apply(null, arguments)
                  },
                },
              },
              [_vm._v("Package/Acquisition Import")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass:
                  "px-3 py-2 cursor-pointer border-0 border-b border-solid border-gray-500 hover:bg-gray-300",
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return (() => {
                      _setup.showDealModal = true
                      _setup.showPopover = false
                    }).apply(null, arguments)
                  },
                },
              },
              [_vm._v("Deal/Sales Import")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass:
                  "px-3 py-2 cursor-pointer border-0 border-b border-solid border-gray-500 hover:bg-gray-300",
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return (() => {
                      _setup.showLoanAllocationModal = true
                      _setup.showPopover = false
                    }).apply(null, arguments)
                  },
                },
              },
              [_vm._v("Loan Allocation Import")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "px-3 py-2 cursor-pointer hover:bg-gray-300",
                attrs: { href: "/DataImport/LegacyLoanImport" },
              },
              [_vm._v("Loan Data Import")]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _setup.showPackageModal
        ? _c(_setup.LegacyPackageImportModal, {
            attrs: {
              "document-url": _vm.documentUrl,
              "data-import-url": _vm.dataImportUrl,
              "legacy-url": _vm.legacyUrl,
              "verification-token": _vm.verificationToken,
            },
            on: {
              close: function ($event) {
                _setup.showPackageModal = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _setup.showDealModal
        ? _c(_setup.LegacyDealImportModal, {
            attrs: {
              "document-url": _vm.documentUrl,
              "data-import-url": _vm.dataImportUrl,
              "legacy-url": _vm.legacyUrl,
              "verification-token": _vm.verificationToken,
            },
            on: {
              close: function ($event) {
                _setup.showDealModal = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _setup.showLoanAllocationModal
        ? _c(_setup.LegacyLoanAllocationModal, {
            attrs: {
              "document-url": _vm.documentUrl,
              "data-import-url": _vm.dataImportUrl,
              "legacy-url": _vm.legacyUrl,
              "verification-token": _vm.verificationToken,
            },
            on: {
              close: function ($event) {
                _setup.showLoanAllocationModal = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }